export default __webpack_public_path__ + "static/media/5.10410959.png";